
const packageJson = require('../package.json');

export function getVersionString() {
    return packageJson.version;
}

export function getAppName() {
    return `PARCELY-ONLINE`;
}

export function getAppNameWithVersion() {
    return `${getAppName()} v${getVersionString()}`;
}
